import { UpsellStep } from "@redotech/redo-flows-common/steps";
import { t } from "@redotech/redo-i18n";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { UpsellInspector } from "./inspectors/upsell-inspector";

export const upsellStepType: FrontendStepType<
  PartialWithRequiredType<UpsellStep>
> = {
  valid: (step) => true,
  type: "standard",
  inspectorFactory: (outerProps) => ({
    header: { title: outerProps.step.name ?? t("Upsell") },
    sections: [
      {
        fields: [
          { path: "name", label: t("Upsell name"), widget: "text" },
          {
            path: "upsellId",
            label: "",
            widget: "custom",
            Element: (props) => {
              return (
                <UpsellInspector
                  doSave={outerProps.save}
                  upsellId={props.value.upsellId ?? ""}
                />
              );
            },
          },
        ],
      },
    ],
  }),
};
